/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {RootScopeService} from "./rootscope.service";
import {ActivatedRoute, Router} from "@angular/router";
import {LangKeyService} from "./lang-key.service";
import {Routes} from '../constant/routes';


@Injectable({
    providedIn: 'root'
})
export class RedirectionService {


    private completed: boolean = false;


    constructor(private spinner: NgxSpinnerService, private rootScope: RootScopeService, private route: ActivatedRoute, private router: Router, private langKeyService: LangKeyService) {

    }


    redirection(promise) {

        let that = this;
        promise.then(
            // resolve -> redirect to inner page
            function (redirect) {
                console.log("Resolve by ", redirect)
                that.spinner.hide('spinner');
                that.spinner.hide('spinner-bottom');
                that.router.navigateByUrl(redirect)

                // reject -> redirect outside
            }, function (hardRedirect) {
                console.log("reject by ", hardRedirect)
                that.spinner.hide('spinner');
                that.spinner.hide('spinner-bottom');
                window.location.href = hardRedirect;
            });

    }

    copyParams(params, redirect) {

        // copy tokenEndpoint params (+ locale)
        let paramMap = params;
        console.log(paramMap)
        if (paramMap['pId']) {
            redirect = redirect + Routes.pIdSuffix
        }
        if (paramMap) {
            for (let param in paramMap) {
                if (Routes.params[param]) {
                    redirect = redirect.replace(Routes.params[param], paramMap[param])
                }
            }
        } else {
            redirect = redirect.replace(Routes.params.locale,
                this.langKeyService.langKey);
        }

        return redirect;
    }

    // public methods
    moveTo(params, redirect, activateIdle) {
        this.rootScope.get().enableIdling(activateIdle);
        // copy tokenEndpoint params (+ locale)
        redirect = this.copyParams(params, redirect);

        this.redirection(Promise.resolve(redirect));
        this.completed = true;
    }

    exit(hardRedirect) {
        this.redirection(Promise.reject(hardRedirect));
        this.completed = true;
    }


    // public explicit redirections
    error(route: ActivatedRoute, reason, sessionId) {
        this.moveTo(route.snapshot.params, Routes.error.replace(Routes.params.reason, reason)
            .replace(Routes.params.sessionId, sessionId), false);
    }

    hold(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.hold.replace(Routes.params.sessionId, sessionId), false);
    }

    cancel(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.canceled.replace(
            Routes.params.sessionId, sessionId), false);
    }

    confirmCancelation(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.confirmCancellation.replace(
            Routes.params.sessionId, sessionId), true);
    }

    session(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.session.replace(Routes.params.sessionId,
            sessionId), true);
    }

    sessionWithParams(params, sessionId) {
        this.moveTo(params, Routes.session.replace(Routes.params.sessionId,
            sessionId), true);
    }

    back() {
        this.completed = true;
        window.history.back();
    }

    unknown(route: ActivatedRoute) {
        this.moveTo(route.snapshot.params, Routes.page404, true);
    }

    summary(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.resume.replace(Routes.params.sessionId,
            sessionId), true);
    }

    smartphoneagreements(route: ActivatedRoute, sessionId, shortId) {
        this.moveTo(route.snapshot.params, (Routes.smartphoneagreements.replace(Routes.params.sessionId,
            sessionId), Routes.smartphoneagreements.replace(Routes.params.shortId,
            shortId)), true);
    }

    transientSummary(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.redirection.replace(Routes.params.sessionId,
            sessionId), true);
    }

    evidences(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.evidences.replace(Routes.params.sessionId,
            sessionId), true);
    }

    agreements(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.agreements.replace(Routes.params.sessionId,
            sessionId), true);
    }

    pendingSignature(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.pendingSignature.replace(Routes.params.sessionId,
            sessionId), true);
    }

    signatures(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.signatures.replace(Routes.params.sessionId,
            sessionId), true);
    }

    // footer
    internalContact(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.contact.replace(Routes.params.sessionId,
            sessionId), true);
    }

    internalHelp(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.help.replace(Routes.params.sessionId,
            sessionId), true);
    }

    internalLegal(route: ActivatedRoute, sessionId) {
        this.moveTo(route.snapshot.params, Routes.legalNotices.replace(
            Routes.params.sessionId, sessionId), true);
    }


    //get redirection as string
    getSSORedirection(route: ActivatedRoute, sessionId, protocol) {
        var url = Routes.agreements.replace(Routes.params.sessionId, sessionId);
        let paramMap = this.route.paramMap;
        // Avoid duplication of ssop param
        // if (!route.snapshot.url.) {
        //     //TODO check how to manage routeParams
        //     //$routeParams.params += '/ssop/' + protocol;
        // }

        return location.href.split('#')[0] + '#' + this.copyParams(route.snapshot.params, url);
    }
}
